/*
  Product gallery: restore the first image.

  With "show only the selected variant's image" switched on, the theme removes
  every variant-linked image when the page loads and only puts one back when a
  variant is chosen. On products where every image belongs to a variant (and
  nothing triggers a variant change on load, e.g. sold-out products) the
  gallery was left empty. This puts the starting variant's image back.
*/
(function () {
  var attempts = 0;

  function restore($gallery, stored, initialId) {
    if (!$gallery.length || !stored || !stored.length) return;
    var flickityInstance = $gallery.data('flickity');
    var cellCount = flickityInstance ? flickityInstance.cells.length : $gallery.children().length;

    var $match = null;
    for (var i = 0; i < stored.length; i++) {
      if (initialId && String(stored[i].data('media-id')) === String(initialId)) {
        $match = stored[i];
        break;
      }
    }
    if (!$match && cellCount === 0) $match = stored[0];
    if (!$match || $.contains($gallery[0], $match[0])) return;

    if (flickityInstance) {
      $gallery.flickity('prepend', $match[0], true);
      $gallery.flickity('select', 0, false, true);
      $gallery.flickity('resize');
    } else {
      $gallery.prepend($match[0]);
    }
  }

  function run() {
    var $ = window.jQuery;
    var ready = $ && Array.isArray(window.productGalleryMedia) && window.productGalleryMedia.length;
    if (!ready) {
      if (attempts++ < 40) setTimeout(run, 250);
      return;
    }
    $('[data-show-only-selected-variant-image]').each(function () {
      var $wrapper = $(this);
      var initialId = $wrapper.attr('data-initial-media-id');
      restore($wrapper.find('[data-product-gallery]').first(), window.productGalleryMedia, initialId);
      restore($wrapper.find('.product_gallery_nav').first(), window.thumbnailGalleryMedia, initialId);
    });
  }

  // Also used after a product is swapped in place (see custom-siblings.js).
  window.shishagearRestoreGallery = function () { attempts = 0; run(); };

  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);
})();
